/*
    This file contains all the requests available for the part categories.
*/
import HttpService from "./http.service";

class PartCategoryService {
    // Get all part codes and their attributes
    getAllPartCategories = async () => {
        const endpoint = 'part-categories';
        return await HttpService.get(endpoint);
    };

    // Create a new Part Code
    createPartCategory = async (payload) => {
        const endpoint = "part-categories";
        return await HttpService.post(endpoint, payload);
    };

    // Get all distinct categories of part codes
    getAllParentCategories = async () => {
        const endpoint = 'part-categories/parent-categories';
        return await HttpService.get(endpoint);
    };

    // Get one part category by id
    getPartCategoryById = async (id) => {
        const endpoint = `part-categories/${id}`;
        const response = await HttpService.get(endpoint);
        return response;
    };

    // Get existing category codes for validation
    getCategoryCodes = async () => {
        const endpoint = `part-categories/cat-codes`
        return await HttpService.get(endpoint);
    };

    // Get part categories by status
    getPartCategoriesByStatus = async (status)=>{
        const endpoint = `part-categories/status/${status}`;
        return await HttpService.get(endpoint);
    };

    // Edit status of a part category
    editStatus = async (id, payload) => {
        const endpoint = `part-categories/status/edit/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    // Edit a part category
    editPartCategory = async (payload, id) => {
        const endpoint = `part-categories/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    // Edit an attribute of a part category
    editAttribute = async (payload,id) => {
        const endpoint = `part-categories/attr/edit/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    // Delete an attribute of a part category
    deleteAttribute = async (payload, id) => {
        const endpoint = `part-categories/attr/delete/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    // Update the order of attributes
    updateAttributesOrder = async (payload, id)=> {
        const endpoint = `part-categories/attr/reorder/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    // Delete a part category
    deletePartCategory = async (id, userId) => {
        const endpoint = `part-categories/${id}/user/${userId}`;
        return await HttpService.delete(endpoint);
    };
}
export default new PartCategoryService();